<template>
	<RowAccordion :model="model">
		<template #right>
			<div class="flex items-center">
				<span class="font-semibold">{{ model.percent }}%</span>
			</div>
		</template>
	</RowAccordion>
</template>

<script>
import personalityResults from '~/mixins/personalityResults'
import RowAccordion from './RowAccordion'

export default {
	name: 'TopTraitsAccordion',
	components: { RowAccordion },
	mixins: [personalityResults],
	props: {
		topTrait: {
			type: Object,
			required: true
		}
	},
	computed: {
		model() {
			return {
				badgeTrait: this.topTrait.trait,
				title: this.displayTraitName(this.topTrait.trait),
				slogan: this.$t(
					`personality_results.trait.${this.topTrait.trait}.slogan`
				),
				description: this.$t(this.topTrait.descriptionKey),
				percent: this.topTrait.percent
			}
		}
	}
}
</script>
